import { render, staticRenderFns } from "./o_pokupka_chek.vue?vue&type=template&id=7051196a&scoped=true&"
import script from "./o_pokupka_chek.vue?vue&type=script&lang=js&"
export * from "./o_pokupka_chek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7051196a",
  null
  
)

export default component.exports